export default __webpack_public_path__ + "static/realWorldImage5-d9d75eff0d81f069c0a701b27257cf03.webp";